export const PDF_IMAGE_ACCEPT = "application/pdf,image/*";

export const PDF_IMAGE_FORMAT_LABELS = ["PDF", "JPG", "PNG"];

export const isPdfOrImageFile = (file?: File | string | null) => {
  if (!file) return true;
  if (!(file instanceof File)) return true;

  return file.type === "application/pdf" || file.type.startsWith("image/");
};
